import cx from 'classnames'
import Image from 'next/image'
import { useContext } from 'react'

import { SanitySimplePortableText } from '@data/sanity/queries/types/content'
import { getPriceWithCurrency } from '@lib/format'
import { getBasicImageLoader } from '@lib/image'
import { ProductCombinedListingContext } from '@lib/product/combined-listing'
import { ShopContext } from '@lib/shop-context'

import SimplePortableText from '@components/simple-portable-text'

interface OptionListItemProps {
  title: string
  description?: SanitySimplePortableText
  price?: number
  photo?: string
  alt?: string
  active?: boolean
  onClick?: () => void
}

const OptionListItem = ({
  title,
  description,
  price,
  photo,
  alt,
  active,
  onClick,
}: OptionListItemProps) => {
  const { currency, taxRate } = useContext(ShopContext)
  const { combinedListingSettings } = useContext(ProductCombinedListingContext)

  return (
    <div
      onClick={onClick}
      className={cx(
        'py-2 pl-2 pr-5 flex gap-4 cursor-pointer',
        active ? 'border-black border-2' : 'border'
      )}
    >
      <Image
        src={photo ?? combinedListingSettings?.noOptionImage?.url ?? ''}
        alt={alt ?? ''}
        width={80}
        height={80}
        loader={getBasicImageLoader}
        className="shrink-0"
      />

      <div className="space-y-0.5">
        <p className="text-sm flex gap-2">
          <span className="font-medium">{title}</span>

          {price && (
            <span>
              +
              {getPriceWithCurrency(price, currency, {
                taxRate,
                showCurrency: true,
                thousandSeparator: ',',
              })}
            </span>
          )}
        </p>

        {description && (
          <SimplePortableText
            content={description}
            className="[&>*]:text-xs [&>*]:leading-[1.4] [&>*]:tracking-[2%] opacity-70"
          />
        )}
      </div>
    </div>
  )
}

export default OptionListItem
